import React, { useState, useEffect } from 'react';

export default function PWAInstallPrompt({ onInstall }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      onInstall?.();
    }
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 20,
      left: 20,
      right: 20,
      background: '#0f172a',
      borderRadius: 16,
      padding: 20,
      boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      fontFamily: "'Montserrat', sans-serif",
    }}>
      <div style={{ fontSize: 40 }}>✈️</div>
      <div style={{ flex: 1 }}>
        <div style={{ color: 'white', fontWeight: 700, fontSize: 16, marginBottom: 4 }}>
          Install GreatBreak App
        </div>
        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>
          Add to home screen for offline access
        </div>
      </div>
      <button
        onClick={handleInstall}
        style={{
          background: '#1a6b4a',
          border: 'none',
          borderRadius: 12,
          padding: '12px 20px',
          color: 'white',
          fontWeight: 700,
          cursor: 'pointer',
          fontSize: 14,
        }}
      >
        Install
      </button>
      <button
        onClick={() => setShowPrompt(false)}
        style={{
          background: 'transparent',
          border: 'none',
          color: 'rgba(255,255,255,0.5)',
          fontSize: 20,
          cursor: 'pointer',
          padding: 4,
        }}
      >
        ✕
      </button>
    </div>
  );
}